export const API_DATE_FORMAT = 'YYYY-MM-DD'
export const FULL_DATE_TIME_FORMAT = 'dddd, MMM DD YYYY HH:mm'
export const SHORT_DATE_TIME_FORMAT = 'ddd, MMM D YYYY'
export const MONTH_DAY_FORMAT = 'MMM-D'
